export default __webpack_public_path__ + "static/flight-bg-1bd66f4c552a8e568096a4b4b0d4caab.svg";